var map = {
	"./arrow.svg": "94c4",
	"./balloon.svg": "ebe9",
	"./coin.svg": "d83c",
	"./history.svg": "fcce",
	"./invitation.svg": "59f9",
	"./my_page.svg": "c959",
	"./news_edit.svg": "467a",
	"./prize.svg": "f078",
	"./team.svg": "be98",
	"./user.svg": "4c64"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb4";